import { render, staticRenderFns } from "./AreaNeed.vue?vue&type=template&id=7327dc00&scoped=true&"
var script = {}
import style0 from "./AreaNeed.vue?vue&type=style&index=0&id=7327dc00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7327dc00",
  null
  
)

export default component.exports